import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import {
  CompanyGoals,
  SmartGoal,
  SmartGoalRequest,
} from "../../pages/Enterprise/modules/SmartGoals/types";

const getCompanyGoals = async (
  id: string,
  mainAccountId?: string
): Promise<SmartGoal[]> => {
  try {
    const response = await axiosInstance.get<SmartGoal[]>(
      `/smart-goals/${id}`,
      { params: { mainAccountId } }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar os Objetivos.",
    });

    throw new Error(`${error}`);
  }
};

const deleteCompanyGoals = async (
  id: string,
  mainAccountId?: string
): Promise<CompanyGoals> => {
  try {
    const response = await axiosInstance.delete<CompanyGoals>(
      `/smart-goals/${id}`,
      { params: { mainAccountId } }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível deletar os Objetivos.",
    });

    throw new Error(`${error}`);
  }
};

const createCompanyGoals = async (
  id: string,
  data: SmartGoalRequest,
  mainAccountId?: string
): Promise<SmartGoalRequest> => {
  try {
    const queryParams = mainAccountId ? `?mainAccountId=${mainAccountId}` : "";
    const response = await axiosInstance.post<SmartGoalRequest>(
      `/smart-goals/${id}${queryParams}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar o Objetivo.",
    });

    throw new Error(`${error}`);
  }
};

export const companyGoalsService = {
  getCompanyGoals,
  createCompanyGoals,
  deleteCompanyGoals,
};
